import { lowerCase, map, uniq, upperFirst } from 'lodash';
import { useMemo } from 'react';

import { LineArea } from '@/charts';
import { ColorIcon, LineIcon } from '@/components/data/ColorIcon';
import { Datum } from '@/components/data/Datum';
import { SalinityChartDatum } from '@/components/spotter/historicalDataTab/SalinityLineChartSection';
import {
    DataDetailDatum,
    DataDetailsSection,
} from '@/components/spotter/historicalDataTab/datumDetail/DataDetailPanel';

export type SalinityDatumDetailProps = {
    datum: SalinityChartDatum;
    dataset: SalinityChartDatum[];
    line: LineArea<SalinityChartDatum>;
};

export const SalinityDatumDetail = ({ datum, line, dataset }: SalinityDatumDetailProps) => {
    const sensorLabel = useMemo(
        () =>
            datum.sensorPosition && uniq(map(dataset, 'sensorPosition')).length > 1
                ? upperFirst(lowerCase(String(datum.sensorPosition)))
                : null,
        [dataset, datum.sensorPosition]
    );

    return (
        <DataDetailsSection label={sensorLabel}>
            <DataDetailDatum label="Salinity" icon={<LineIcon color={line.color.line} dot />}>
                <Datum value={datum.salinity} type={datum.unitType} sourceUnit={datum.units} />
            </DataDetailDatum>
            <DataDetailDatum label="Std. deviation" icon={<ColorIcon color={line.color.area} />}>
                <Datum
                    value={datum.salinityStdDev}
                    type={datum.unitType}
                    sourceUnit={datum.units}
                    minimumDisplayValue={0.001}
                />
            </DataDetailDatum>
        </DataDetailsSection>
    );
};
